export const HEATING_FORM_DATA_ID = 'react-data-heating-form'
/** A prefix for form fields, so that they are unique. E.g. id="name" would be prefixed to id="o-heating-form_name" */
export const FORM_FIELD_ID_PREFIX = 'o-heating-form_';
export const CSS_FONT_SAIRA = "Saira";
export const CSS_FONT_INTER = "Inter";
